// @flow

import React from 'react';
import type {Cryptocurrency} from '@tectonics/commons/cryptocurrency/cryptocurrencies/cryptocurrency-type';
import UsdtIcon from './usdt-icon';
import {erc20} from '@tectonics/commons/cryptocurrency/protocol/erc20/erc20';
import {trc20} from '@tectonics/commons/cryptocurrency/protocol/trc20/trc20';
import {polygon} from '@tectonics/commons/cryptocurrency/protocol/polygon/polygon';
import {bep20} from '@tectonics/commons/cryptocurrency/protocol/bep20/bep20';

export const usdt: Cryptocurrency = {
  code: 'usdt',
  icon: <UsdtIcon alt="usdt"/>,
  abbreviation: 'USDT',
  name: 'USDT (Tether)',
  protocols: [erc20, trc20, polygon, bep20],
};
